import { render, staticRenderFns } from "./CollaboratorDetailForAlbum.vue?vue&type=template&id=2ff16273&scoped=true&"
import script from "./CollaboratorDetailForAlbum.vue?vue&type=script&lang=js&"
export * from "./CollaboratorDetailForAlbum.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorDetailForAlbum.vue?vue&type=style&index=0&id=2ff16273&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff16273",
  null
  
)

export default component.exports